'use strict';

import Analytics from '../../_common/js/modules/analytics';
import analyticsEvents from '../../_common/js/modules/analyticsEvents';
import announcementBar from '../../_common/js/modules/announcement';
import gdprCookie from '../../_common/js/modules/gdprCookie';
import Cookies from '../../_common/js/modules/cookies';
import intlPhoneInput from '../../_common/js/modules/intlPhoneInput';
import pricing from '../../_common/js/modules/pricingFreshworks';
import mobileMenu from '../../_common/js/modules/mobileMenu';
import stickyMainMenu from '../../_common/js/modules/stickyMainMenu';
import userParams from '../../_common/js/modules/userParams';
import contactForm from '../../_common/js/modules/contactForm';
import popupButtons from '../../_common/js/modules/popupButtons';

( function( document, window ) {
    const analytics = Analytics();
    const cookiesGeneral = Cookies( 'HDM' );

    // Ready
    document.addEventListener( 'DOMContentLoaded', function() {
        stickyMainMenu();

        const phoneInputs = document.querySelectorAll( 'input[type=tel]' );
        if ( phoneInputs.length ) {
            intlPhoneInput( phoneInputs );
        }

        const chatBtn = document.querySelector( '.zendesk-btn' );
        const wizardBtn = document.querySelector( '.wizard-caption-btn' );
        const calendlyBtn = document.querySelector( '.calendly-btn' );
        if ( chatBtn || wizardBtn || calendlyBtn ) {
            popupButtons();
        }

        userParams( cookiesGeneral );

        const navMobile = document.querySelector( '*[data-bs-target="#navbarMobileMainMenu"]' );
        if ( navMobile ) {
            mobileMenu();
        }

        const announcementBarElement = document.querySelector( '.announcement-bar' );
        if ( announcementBarElement ) {
            announcementBar( cookiesGeneral, announcementBarElement );
        }

        const gdprCookieElement = document.getElementById( 'tuna_gdpr__cookie' );
        if ( gdprCookieElement ) {
            gdprCookie( cookiesGeneral, gdprCookieElement );
        }

        const pricingForm = document.querySelector( '.pricing-form' );
        if ( pricingForm ) {
            pricing();
        }

        const wpcf7Form = document.querySelector( '.wpcf7-form' );
        if ( wpcf7Form ) {
            contactForm();
        }

        const eventBtns = document.querySelectorAll( '[data-ga-action]' );
        if ( eventBtns.length > 0 ) {
            analyticsEvents( analytics, eventBtns );
        }
    } );
}( document, window ) );
